import { factoryYup } from 'app/core/factory-yup';
import i18next from 'i18next';

const yup = factoryYup();

const validations = yup.object().shape({
  comments: yup.string().required(i18next.t('common.validations.fieldRequired')).max(1024),
  sections: yup.array().of(
    yup.object().shape({
      comment: yup.string().max(1024)
    })
  )
});

export default validations;
